import angular  from 'angular'
import uiRouter from 'angular-ui-router'

import component from './manage-my-rlink.component'

import MyPurchaseRecordsPage  from './my-purchase-records'
import MyUpdatesPage          from './my-updates'
import Components             from './components'

let module = angular.module('manageMyRlink', [
  uiRouter,
  Components,
  MyPurchaseRecordsPage,
  MyUpdatesPage
])

.config(($stateProvider) => {
  'ngInject'

  $stateProvider
    .state('vehicle.manageMyRlink', {
      url: '/manage',
      component: 'manageMyRlink',
      redirectTo: 'vehicle.manageMyRlink.myPurchaseRecords',
      authenticate: true
    })
})

.component('manageMyRlink', component)

.name

export default module



// WEBPACK FOOTER //
// ./src/app/pages/vehicle/manage-my-rlink/index.js